









import { defineComponent, computed, PropType } from '@vue/composition-api';
import { AdjustQuotaType, AdjustTypeEnum } from '@/dict/quotaIncrease-type';

/**
 * 额度调整信息，如：含临时额度1000元，将于06月20日到期
 */
export default defineComponent({
  name: 'AdjustQuotaInfo',
  props: {
    adjustQuota: {
      type: Object as PropType<AdjustQuotaType>,
      required: true,
    },
  },
  setup(props) {
    const minorText = computed(() => {
      const { adjustType, adjustValue = 0, tempCreditExpiryTime = '' } = props.adjustQuota;

      if (Number(adjustValue)) {
        if (adjustType === AdjustTypeEnum.INCREASE) {
          return `额度已提升+${adjustValue}元`;
        }
        if (adjustType === AdjustTypeEnum.TEMP) {
          return `含临时额度${adjustValue}元，将于${tempCreditExpiryTime}到期`;
        }
      }

      return '';
    });

    return {
      minorText,
    };
  },
});
